import S from './utils/Selector';
import eventEmitter from '@/utils/eventEmitter';
import './../scss/style.scss';

/* Defining components */
const components = [
	{
		path: 'utils/LazyLoad',
		name: 'LazyLoad'
	},
	{
		path: 'components/cards/CardElement',
		name: 'cardElement'
	},
	{
		path: 'components/cards/CardCollection',
		name: 'cardCollection'
	},
	{
		path: 'components/cards/CardTeacher',
		name: 'cardTeacher'
	},
	{
		path: 'components/cards/CardFolder',
		name: 'cardFolder'
	},
	{
		path: 'components/player/Player',
		name: 'Player'
	},
	{
		path: 'components/misc/SearchMultiSelect',
		name: 'searchMultiSelect'
	},
	{
		path: 'components/menu/UserNavigation',
		name: 'userNavigation'
	},
	{
		path: 'components/header/Hamburger',
		name: 'hamburger'
	},
	{
		path: 'components/header/MobileSearch',
		name: 'mobilesearch'
	},
	{
		path: 'components/Slider',
		name: 'slider'
	},
	{
		path: 'pages/Profiling/ListScrollable',
		name: 'ListScrollable'
	},
	{
		path: 'pages/Profiling/MultiSelect',
		name: 'MultiSelect'
	},
	{
		path: 'pages/Profiling/Vote',
		name: 'Vote'
	},
	{
		path: 'pages/Profiling/RangeList',
		name: 'RangeList'
	},
	{
		path: 'pages/Profiling/TextProject',
		name: 'TextProject'
	},
	{
		path: 'components/player/PlayerOptions',
		name: 'PlayerOptions'
	},
	{
		path: 'components/player/Element_mobile',
		name: 'Element_mobile'
	},
	{
		path: 'components/misc/InstrumentSwitch',
		name: 'InstrumentSwitch'
	},
	{
		path: 'components/element/Element',
		name: 'Element'
	},
	{
		path: 'components/misc/FollowTeacher',
		name: 'FollowTeacher'
	},
	{
		path: 'components/header/UserPopup',
		name: 'userPopup'
	},
	{
		path: 'components/menu/Header',
		name: 'header'
	},
	{
		path: 'pages/MusicalProfile/MusicalProfile',
		name: 'musicalProfile'
	},
	{
		path: 'pages/MusicalProfile/Skill',
		name: 'skill'
	},
	{
		path: 'pages/MusicalProfile/InfosStats',
		name: 'InfosStats'
	},
	{
		path: 'components/StatusMessages/StatusMessages',
		name: 'StatusMessages'
	},
	{
		path: 'components/misc/SkillTree/SkillTreeStandalone',
		name: 'SkillTreeStandalone'
	},
	{
		path: 'components/misc/Faq',
		name: 'Faq'
	},
	{
		path: 'pages/Profiling/Profiling',
		name: 'Profiling'
	},
	{
		path: 'utils/CustomDOMLoader',
		name: 'CustomDOMLoader'
	},
	{
		path: 'components/misc/ValidateField',
		name: 'ValidateField'
	},
	{
		path: 'components/misc/ViewsCount',
		name: 'ViewsCount'
	},
	{
		path: 'components/form/RegisterForm',
		name: 'RegisterForm'
	},
	{
		path: 'components/cards/CardWorkshop',
		name: 'cardWorkshop'
	}
];
/* End defining components */

/* Defining functions */
function manageHistory() {
	const sessionHistory = JSON.parse(sessionStorage.getItem('history')); // get existing history
	const hist = sessionHistory ? sessionHistory : []; // si pas d'historique car première page chargée
	if (document.location.href !== hist[hist.length - 1]) {
		hist.push(document.location.href); // on ajoute la page actuelle
		sessionStorage.setItem('history', JSON.stringify(hist)); // on stock le nouvel historique
	}

	const fromConfirmation = sessionStorage.getItem('fromConfirmation');
	if (fromConfirmation) {
		sessionStorage.removeItem('fromConfirmation');
		document.location.href = fromConfirmation;
	}
	if (hist.length > 1) {
		const backnav = S.get(document, 'Backnav');
		if (backnav) {
			if (!document.querySelector('.wp-home')) {
				backnav.classList.add('Backnav--visible');
			}

			backnav.addEventListener('click', () => {
				const wrapper = document.querySelector('.Wrapper');
				if (wrapper && wrapper.dataset.confirmation) {
					sessionStorage.setItem('fromConfirmation', hist[hist.length - 2]);
					document.location.href = wrapper.dataset.logout;
				} else {
					hist.pop(); // on enlève l'URL actuelle de l'historique
					const urlToGo = hist.pop(); // on enlève l'URL précédente vers laquelle on va
					sessionStorage.setItem('history', JSON.stringify(hist)); // on update l'historique
					document.location.href = urlToGo;
				}
			});
		}
	}
}

function instanciateModule(module, componentName) {
	Array.from(S.getAllComponents(document, componentName)).forEach(componentElement => {
		if (
			typeof module.default === 'function' &&
			componentElement.getAttribute('wp-js-cpt-init') !== '1'
		) {
			/* le dom du composant searchMultiselect n'est pas "reactualisé", seul son contenu l'est du coup, une fois init, il l'est pour toujours, on prefere le considérer comme jamais init*/
			new module.default(componentElement);
			if (componentName !== 'searchMultiSelect') {
				componentElement.setAttribute('wp-js-cpt-init', '1');
			}
		}
	});
}

function importModule(componentName, importFn) {
	if (S.getComponent(document, componentName)) {
		importFn()
			.then(module => {
				instanciateModule(module, componentName);
			})
			.catch(err => console.error('module: ', componentName, err));
	}
}

function handleDatepickerLanguage() {
	const Langue = document.documentElement.lang;
	if (Langue === 'fr') {
		if (typeof window.jQuery('.datepicker').datepicker === 'function') {
			window
				.jQuery('.datepicker')
				.datepicker({
					regional: 'fr',
					yearRange: 'c-80:c',
					dateFormat: 'yy-mm-dd',
					changeMonth: true,
					changeYear: true,
					constrainInput: true,
					showOn: 'button',
					readonly: 'readonly',
					dayNames: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
					onClose: function(date, El) {
						eventEmitter.emit('inputInsertData', El);
					}
				})
				.attr('readonly', 'readonly');
		}
	} else if (Langue === 'en') {
		if (typeof window.jQuery('.datepicker').datepicker === 'function') {
			window
				.jQuery('.datepicker')
				.datepicker({
					regional: 'en',
					yearRange: 'c-80:c',
					dateFormat: 'yy-mm-dd',
					changeMonth: true,
					changeYear: true,
					showOn: 'button',
					readonly: 'readonly',
					dayNames: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
					onClose: function(date, El) {
						eventEmitter.emit('inputInsertData', El);
					}
				})
				.attr('readonly', 'readonly');
		}
	}
}

function instanciateAOS(module) {
	const link = document.createElement('link');
	link.href = '/themes/custom/wp/vendor/aos.css';
	link.rel = 'stylesheet';
	document.head.appendChild(link);

	window.AOS = module.default;
	window.AOS.init({
		// Global settings
		disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
		startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
		initClassName: 'aos-init', // class applied after initialization
		animatedClassName: 'aos-animate', // class applied on animation
		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

		// Settings that can be overriden on per-element basis, by `data-aos-*` attributes:
		offset: 120, // offset (in px) from the original trigger point
		delay: 0, // values from 0 to 3000, with step 50ms
		duration: 400, // values from 0 to 3000, with step 50ms
		easing: 'ease', // default easing for AOS animations
		once: false, // whether animation should happen only once - while scrolling down
		mirror: false, // whether elements should animate out while scrolling past them
		anchorPlacement: 'top-bottom' // defines which position of the element regarding to window should trigger the animation
	});
}

function main() {
	window.eventEmitter = eventEmitter;

	/* REACT */
	setTimeout(() => {
		importModule('ReactComponent', () => import('@ReactCore/Instance/index'));
	}, 0);
	/* AOS */
	if (document.querySelector('[wp-js-aos]')) {
		setTimeout(() => {
			import('aos').then(instanciateAOS);
		}, 0);
	}

	/* COMPONENTS */
	setTimeout(() => {
		components.forEach(component => {
			importModule(component.name, () => import(`./${component.path}`));
		});
	}, 0);

	manageHistory();
	setTimeout(handleDatepickerLanguage, 10);
}

window.initComps = function(name) {
	let t = components.find(e => e.name === name);
	import(`./${t.path}`)
		.then(module => {
			instanciateModule(module, t.name);
		})
		.catch(err => console.error('module: ', t.name, err));
};
/* End defining components */

/* Running code */
// simple check envers les vieux malandrins
const isEdge = /Edge/.test(navigator.userAgent);
const edgeVersion = Math.floor(navigator.userAgent.slice(navigator.userAgent.indexOf('Edge') + 5));
if (
	isEdge &&
	edgeVersion < 16 &&
	(!window.drupalSettings.isLandingPage || document.location.pathname.indexOf('/contact') < 0)
) {
	// stop toi ici lascars
	const message = document.querySelector('.EdgeMessage');
	message.style.display = '';
} else {
	// tu peux passer
	window.addEventListener('DOMContentLoaded', main);
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function(e) {
		e.preventDefault();

		document.querySelector(this.getAttribute('href')).scrollIntoView({
			behavior: 'smooth'
		});
	});
});
